import api from './api'; // Asumo que tienes una instancia de axios configurada en 'api.js'

/**
 * @description Realiza una llamada al backend para obtener los datos de geolocalización del usuario.
 * @returns {Promise<object>} Un objeto con { country, currency, language }.
 */
export const fetchLocationData = async () => {
  try {
    const { data } = await api.get('/location/details');
    return data;
  } catch (error) {
    console.error('Error fetching location data:', error);
    // Devuelve un objeto por defecto en caso de error para que la app no se rompa.
    return {
      country: 'AR',
      currency: 'ARS',
      language: 'es',
    };
  }
};
